<template>
	<div>
		<div v-if="show" class="c-search__auto-suggest" :class="isProductPage ? 'c-search__auto-suggest--product-page' : ''">
			<auto-suggest-item v-for="(suggestion, i) in suggestions"
							   :key="suggestion.url"
							   :suggestion="suggestion"
							   :index="i"
							   :is-product-page="isProductPage"
							   :selected-index="selectedIndex"
							   ref="suggestions"
							   :property-group-delimiter="propertyGroupDelimiter"
							   :actionLabel="actionLabel"
							   :register-with-observer="registerWithObserver"
							   :ecommerce-tracking-data="ecommerceTrackingData"
							   data-testid="auto-suggest-item"
							   :tracking-enabled="trackingEnabled"
			>
			</auto-suggest-item>
		</div>
	</div>
</template>

<script>
import { itemListIdAndName } from 'shared/settings/constants';
import AutoSuggestItem from 'shared/components/product/autoSuggestItem.vue';
import intersectionObserverMixin from 'shared/mixins/intersectionObserverMixin';
import { track_view_item_list } from 'shared/services/tracking/productTrackingService';

export default {
	name: 'auto-suggest',
	components: {
		AutoSuggestItem,
	},
	mixins: [
		intersectionObserverMixin,
	],
	props: [
		'suggestions',
		'propertyGroupDelimiter',
		'selectedIndex',
		'actionLabel',
		'isProductPage',
		'ecommerceTrackingData',
		'trackingEnabled',
	],
	methods: {
		async onProductsObserved(productElements) {
			let observedProducts = [];
			productElements.forEach(({ target, isIntersecting }) => {
				if (!isIntersecting) {
					return;
				}
				// call the unregisterFromObserver method that comes from the observer mixin
				this.unregisterFromObserver(target);
				const i = Number(target.dataset.index);
				const product = this.suggestions[i];
				product.index = i;
				observedProducts.push(product);
			})
			if (observedProducts.length > 0) {
				track_view_item_list({
					productsDto: { globalTrackingParameters: this.ecommerceTrackingData.value },
					observedProducts,
					itemListIdAndName: itemListIdAndName.AUTO_SUGGEST_SEARCH
				});
			}
		},
	},
	computed: {
		show() {
			return this.suggestions && this.suggestions.length > 0;
		}
	},
	watch: {
		selectedIndex() {
			if (this.selectedIndex >= 0 && this.$refs.suggestions?.[this.selectedIndex]) {
				this.$refs.suggestions[this.selectedIndex].$el.scrollIntoView();
			}
		}
	},
	created() {
		// init tracking only when trackingEnabled is trusy
		if(this.trackingEnabled) {
			this.intializeObserver(this.onProductsObserved, {
				threshold: 0.6,
			});
		}
	}
}
</script>
